import _slicedToArray from "/Users/ashwanthar/Desktop/github/equidistant-color-hash-example/node_modules/@babel/runtime/helpers/esm/slicedToArray";

var generateHash = function generateHash(str) {
  return str.split("").reduce(function (hash, char) {
    return hash + char.charCodeAt(0);
  }, 0);
};

var RGB2HEX = function RGB2HEX(RGBArray) {
  return RGBArray.reduce(function (hex, rgb) {
    if (rgb < 16) return "".concat(hex, "0").concat(rgb.toString(16));
    return hex + rgb.toString(16);
  }, "#");
};

var HSL2RGB = function HSL2RGB(H, S, L) {
  var q = L < 0.5 ? L * (1 + S) : L + S - L * S;
  var p = 2 * L - q;
  return [H + 1 / 3, H, H - 1 / 3].map(function (color) {
    var preRGB = color < 0 && color + 1 || color > 1 && color - 1 || color;
    if (preRGB < 1 / 6) preRGB = p + (q - p) * 6 * preRGB;else if (preRGB < 0.5) preRGB = q;else if (preRGB < 2 / 3) preRGB = p + (q - p) * 6 * (2 / 3 - preRGB);else preRGB = p;
    return Math.round(preRGB * 255);
  });
};

var hsl = function hsl(hash, hue, lightness, saturation) {
  var hueValue = hash % 727 * (hue.max - hue.min) / 727 + hue.min;
  var newHash = parseInt(hash / 360, 10);
  var satValue = saturation[newHash % saturation.length];
  newHash = parseInt(newHash / saturation.length, 10);
  var lightValue = lightness[newHash % lightness.length];
  return [hueValue, satValue, lightValue];
};

var generateHex = function generateHex(H, S, L) {
  return RGB2HEX(HSL2RGB(H / 360, S, L));
};

var generateColorHash = function generateColorHash(_ref) {
  var _ref$list = _ref.list,
      list = _ref$list === void 0 ? [] : _ref$list,
      _ref$hue = _ref.hue,
      hue = _ref$hue === void 0 ? {
    min: 0,
    max: 359
  } : _ref$hue,
      _ref$lightness = _ref.lightness,
      lightness = _ref$lightness === void 0 ? [0.2, 0.3, 0.4, 0.5, 0.6, 0.7] : _ref$lightness,
      _ref$saturation = _ref.saturation,
      saturation = _ref$saturation === void 0 ? [0.35, 0.5, 0.65] : _ref$saturation;

  try {
    if (list.length > 0) {
      var hashCode = generateHash(list[0]);

      var _hsl = hsl(hashCode, hue, lightness, saturation),
          _hsl2 = _slicedToArray(_hsl, 3),
          H = _hsl2[0],
          S = _hsl2[1],
          L = _hsl2[2];

      var listLength = list.length + 1;
      return list.map(function (str, index) {
        var newH = H + index * (360 / listLength);
        return generateHex(newH, S, L);
      });
    } else throw new Error("Generating color hash failed. Need to pass in an array of atleast one element");
  } catch (error) {
    console.error(error);
  }
};

export default generateColorHash;